import cl from 'classnames'

export const Divider = ({ color = '#d3dff0', isVertical = false }) => {
	return (
		<hr className={cl('hr', {
			'vr': isVertical,
			'h-100': isVertical,
		} )} style={{ backgroundColor: color }} />
	)
}